import { render, staticRenderFns } from "./SafetyConfirmFamiliesModal.vue?vue&type=template&id=01c5f420&lang=pug"
import script from "./SafetyConfirmFamiliesModal.vue?vue&type=script&lang=ts"
export * from "./SafetyConfirmFamiliesModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports